import { CITY_PRODUCT_ROUTE, PRODUCT_ROUTE } from '../../../routes/constant';

// ResourceResponse::make(ProductResource::collection($paginator)) can carry
// a plain data array or a Laravel paginator's nested `data` array.
export const unpackProductSearchResults = (response) => {
  if (response?.success === false || response?.response === false) {
    throw new Error(response?.message || 'Product search failed.');
  }

  const payload = response?.data;
  const results = Array.isArray(payload)
    ? payload
    : Array.isArray(payload?.data)
      ? payload.data
      : [];

  return results.filter((item) => item && typeof item === 'object');
};

// The app does not have a /product/:slug route. Use the actual catalog route.
export const getProductSearchPath = (item, city) => {
  const categorySlug = item?.category?.slug || item?.brand?.category?.slug;
  const brandSlug = item?.brand?.slug;
  const productSlug = item?.slug;
  if (!categorySlug || !brandSlug || !productSlug) return null;

  return city?.slug
    ? CITY_PRODUCT_ROUTE(city.slug, categorySlug, brandSlug, productSlug)
    : PRODUCT_ROUTE(categorySlug, brandSlug, productSlug);
};
